import React, { useContext } from 'react'
import  ReactPlayer from 'react-player';
import { UserContext } from '../../App';
import { IoChevronBackCircleSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';



function Videoedit() {
    const {theme,setTheme} = useContext(UserContext)
  return (
    <>

    <div style={{paddingTop:"5rem"}} className={theme==0?'vedits-light':'vedits-dark'}>
      <center className={theme==0?'name-light':'name-dark'}><Link to="/services"><IoChevronBackCircleSharp/>Video Editing</Link></center>
      <div className='video-list'>
      <ReactPlayer className="video" controls url="https://www.youtube.com/watch?v=yVMPje7_E_o"  />
      <ReactPlayer className="video" controls url="https://www.youtube.com/watch?v=O9wVP_tr78o" />
      <ReactPlayer className="video" controls url="https://www.youtube.com/watch?v=SqSos3cUdYM"  />
      </div>
    </div>
    </>
  )
}

export default Videoedit
